import { render, staticRenderFns } from "./pessoa-container.vue?vue&type=template&id=80cf6ece&"
import script from "./pessoa-container.vue?vue&type=script&lang=ts&"
export * from "./pessoa-container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80cf6ece')) {
      api.createRecord('80cf6ece', component.options)
    } else {
      api.reload('80cf6ece', component.options)
    }
    module.hot.accept("./pessoa-container.vue?vue&type=template&id=80cf6ece&", function () {
      api.rerender('80cf6ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/pessoa-container.vue"
export default component.exports